@if ((data?.url ?? url()) && !(data?.blob ?? blob())) {
  <div class="view" [style.position]="'relative'">
    @if (
      !previewFailed() &&
      ((!show() && formatControl?.value !== 'html') ||
        (formatControl?.value === 'html' && (previewHtml$ | async) === null))
    ) {
      <mat-spinner class="spinner" />
    }
    @if (
      (data?.baseLanguage ?? baseLanguage()) &&
      !(data?.hideLangs ?? hideLangs())
    ) {
      <div class="preview-actions">
        <language-buttons
          class="lang-buttons"
          [langs]="langs()"
          [hideLabel]="true"
          [langsAllowed]="
            formatControl?.value === 'html'
              ? 1
              : (data?.numberLanguages ?? numberLanguages())
          "
          [multiRequired]="data?.multiRequired ?? multiRequired()"
          (langsChange)="langsChanged($event)"
        />
        <mat-button-toggle-group
          class="toggle-switch"
          [formControl]="formatControl"
          aria-label="Preview mode"
        >
          <mat-button-toggle value="pdf">{{
            'pdf_preview.view.print' | transloco
          }}</mat-button-toggle>
          <mat-button-toggle value="html">{{
            'pdf_preview.view.mobile' | transloco
          }}</mat-button-toggle>
        </mat-button-toggle-group>
        @if (showRefresh()) {
          <button
            mat-button
            color="primary"
            class="refresh"
            (click)="refresh()"
          >
            {{ 'pdf_preview.refresh' | transloco }}
          </button>
        }
      </div>
    }
    <div class="viewer-container" [class.non-modal]="nonModal()">
      @if (previewFailed()) {
        <div class="preview-error" role="alert" aria-live="assertive">
          <mat-icon class="preview-error__icon" aria-hidden="true"
            >cloud_off</mat-icon
          >
          <p class="preview-error__message">
            {{ 'pdf_preview.error.message' | transloco }}
          </p>
          <button
            mat-flat-button
            color="primary"
            data-cy="retry-preview"
            (click)="refresh()"
          >
            {{ 'pdf_preview.error.retry' | transloco }}
          </button>
        </div>
      } @else if (
        formatControl?.value === 'pdf' &&
        (data?.htmlPreview ?? htmlPreview()) &&
        (previewPdfHtml$ | async) !== null
      ) {
        <app-pdf-html-preview
          class="html-viewer"
          [html]="previewPdfHtml$ | async"
        />
      } @else if (
        formatControl?.value === 'pdf' &&
        !(data?.htmlPreview ?? htmlPreview()) &&
        src() !== null
      ) {
        <pdf-viewer
          #pdfViewer
          *pageSelector="true; let currentPage = page; let showPages = onLoad"
          class="viewer rendered-pdf"
          [class.rendered]="show()"
          [autoresize]="true"
          [original-size]="false"
          [fit-to-page]="true"
          [page]="currentPage"
          [render-text]="true"
          [src]="src()"
          [show-all]="false"
          [show-borders]="true"
          [stick-to-page]="false"
          [zoom-scale]="'page-fit'"
          (after-load-complete)="
            renderPdf($event);
            pdfViewer.updateSize();
            showPages($event, holdPage ? +currentPage : 1);
            holdPage = false
          "
          (page-rendered)="pageRendered()"
          (error)="onPdfViewerError()"
        />
      }
      @if (
        !previewFailed() &&
        formatControl?.value === 'html' &&
        (previewHtml$ | async) !== null
      ) {
        <app-html-preview
          class="html-viewer"
          [htmlPreview]="previewHtml$ | async"
        />
      }
    </div>
  </div>
}
@if (data?.blob ?? blob()) {
  <div class="blob-image">
    <img [src]="src()" alt="" />
  </div>
}
@if (!nonModal() && !hideButtons()) {
  <mat-dialog-actions class="options" [class.non-modal]="nonModal()">
    <button mat-button (click)="printDocument()">
      <mat-icon class="icon print">print</mat-icon
      >{{ 'pdf_preview.actions.print' | transloco }}
    </button>
    <button mat-button [disabled]="isDownloading()" (click)="downloadPdf()">
      <mat-icon
        class="icon"
        [style.display]="isDownloading() ? 'none' : 'inline-block'"
        >file_download</mat-icon
      >
      <spinner
        [style.display]="isDownloading() ? 'inline-block' : 'none'"
        class="download-spinner"
        [config]="{ radius: 7 }"
      />
      {{ 'pdf_preview.actions.download' | transloco }}
    </button>
  </mat-dialog-actions>
}
